import React, { useState } from 'react';
import { Popover, Button, Select, Space, message, App, Tag } from 'antd';
import { EditOutlined, CheckOutlined } from '@ant-design/icons';
import { Participant } from './TeacherOlympiadList';
import { postRequest } from '../../../../api/httpRequest';

interface SecondTourStatusPopoverProps {
    participant: Participant;
    olympiadId: number;
    onStatusUpdate?: () => void;
}

const SecondTourStatusPopover: React.FC<SecondTourStatusPopoverProps> = ({
    participant,
    olympiadId,
    onStatusUpdate
}) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(participant.secondTourStatus)
    
    const { notification } = App.useApp();

    const statusOptions = [
        { value: 'participant', label: 'Участник' },
        { value: 'prizewinner', label: 'Призер' },
        { value: 'winner', label: 'Победитель' },
    ];

    const handleSaveStatus = async () => {
        if (!status) {
            message.warning('Выберите статус');
            return;
        }

        setLoading(true);
        try {
            await postRequest('/server/olympiad/teacher/secondTourStatus', {
                participantId: participant.id,
                olympiadId: olympiadId,
                status: status
            });

            message.success('Статус сохранен');
            setVisible(false);
            
            if (onStatusUpdate) {
                onStatusUpdate();
            }
        } catch (error) {
            console.error('Ошибка при сохранении статуса:', error);
            notification.error({
                message: 'Ошибка сохранения',
                description: 'Не удалось сохранить статус'
            });
        } finally {
            setLoading(false);
        }
    };

    const getStatusTag = (statusValue: any) => {
        switch (statusValue) {
            case 'participant':
                return <Tag color="blue">Участник</Tag>;
            case 'prizewinner':
                return <Tag color="orange">Призер</Tag>;
            case 'winner':
                return <Tag color="green">Победитель</Tag>;
            default:
                return <Tag>Не указан</Tag>;
        }
    };

    const content = (
        <div style={{ width: 250 }}>
            <Space direction="vertical" style={{ width: '100%' }} size="middle">
                <div>
                    <strong>Участник:</strong> {participant.fio}
                </div>
                <div>
                    <strong>Текущий статус:</strong> {getStatusTag(participant)}
                </div>
                <Select
                    placeholder="Выберите статус"
                    value={status}
                    onChange={setStatus}
                    options={statusOptions}
                    style={{ width: '100%' }}
                />
                <Button
                    type="primary"
                    icon={<CheckOutlined />}
                    onClick={handleSaveStatus}
                    loading={loading}
                    style={{ width: '100%' }}
                >
                    Сохранить статус
                </Button>
            </Space>
        </div>
    );

    return (
        <Popover
            content={content}
            title="Статус участия во втором туре"
            trigger="click"
            open={visible}
            onOpenChange={setVisible}
            placement="left"
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {getStatusTag(participant.secondTourStatus)}
                <Button 
                    type="link" 
                    icon={<EditOutlined />}
                    size="small"
                >
                    Изменить
                </Button>
            </div>
        </Popover>
    );
};

export default SecondTourStatusPopover;